import React, { useContext, useState, useEffect } from "react";
import BannerSection from "../inc/BannerSection";
import Banner from "../images/banner.jpg";
import Form from "react-bootstrap/Form";
import RangeSlider from "react-bootstrap-range-slider";
import { FaStar, FaHeart, FaRegHeart } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";

import StickyBox from "react-sticky-box";
import ConstConfig from "../../utility/configs/constConfig";
import ImageConfig from "../../utility/configs/imageConfig";
import ApiService from "../../utility/services/ApiService";
import { AuthContext } from "../../utility/services/AuthContext";
import Functions from "../../utility/services/Functions";

import { Tooltip } from "react-tooltip";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { MultiSelect } from "react-multi-select-component";

import StarRatings from "react-star-ratings";
import FavLoader from "../common/FavLoader";
import UserAvatar from "../common/UserAvatar";
import { trackScreenView, trackButtonClick, trackEvent } from "../../utility/services/analyticsService";
/*eslint eqeqeq: "off"*/

const daysInitialArr = [
  {
    id: 1,
    checked: false,
    day: "Mon",
  },
  {
    id: 2,
    checked: false,
    day: "Tue",
  },
  {
    id: 3,
    checked: false,
    day: "Wed",
  },
  {
    id: 4,
    checked: false,
    day: "Thu",
  },
  {
    id: 5,
    checked: false,
    day: "Fri",
  },
  {
    id: 6,
    checked: false,
    day: "Sat",
  },
  {
    id: 7,
    checked: false,
    day: "Sun",
  },
];

const experienceArr = [
  {
    id: 8,
    checked: false,
    title: "0-1 Years",
    startValue: 0,
    endValue: 1,
  },
  {
    id: 9,
    checked: false,
    title: "1-3 Years",
    startValue: 1,
    endValue: 3,
  },
  {
    id: 10,
    checked: false,
    title: "3-5 Years",
    startValue: 3,
    endValue: 5,
  },
  {
    id: 11,
    checked: false,
    title: "5+ Years",
    startValue: 5,
    endValue: "",
  },
];

const FindTherapist = () => {
  //  LOGICAL FUNCTIONS

  const [specialityList, setSpecialityList] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const [languageList, setlanguageList] = useState([]);
  const [initial_loading, setInitialLoading] = useState(false);
  const [clear_field_state, setClearFieldState] = useState(false);

  const { consoleService, getStars, extractQueryFromUrl, enctyptDataFun } =
    Functions();
  const {
    filter_therapist,
    filter_therapist_public,
    get_speciality_types,
    get_states,
    get_speciality,
    get_language_list,
    add_to_favorite,
  } = ApiService();
  const {
    setLoading,
    user,
    state,
    setState,
    speciality,
    setSpeciality,
    price,
    setPrice,
    online,
    setOnline,
    offline,
    setOffline,
    all,
    setAll,
    name,
    setName,
    gender,
    setGender,
    language,
    setLanguage,
    rating,
    setRating,
    searchQuery,
    submited_find_query,
    setSubmitedFindQuery,
    page_no,
    setPageNo,
    setAuthRole,
  } = useContext(AuthContext);
  const isUser = user.access_token;
  const navigate = useNavigate();

  // DATA VARIABLES

  const [daysArray, setDaysArray] = useState([...daysInitialArr]);
  const [experienceArray, setExperienceArray] = useState([...experienceArr]);
  const [therapistList, setTherapistList] = useState([]);
  const [totalPages, setTotalPages] = useState("");
  const [totalDocs, setTotalDocs] = useState("");
  const [selected_card, setSeletcedCard] = useState(null);
  const [fav_loading, setFavLoading] = useState(false);

  const userDetails = user.details ? user.details : null;
  const isUserDetails = userDetails != null;
  const userRole = isUserDetails ? userDetails.role : null;
  const isRoleTherapist = userRole == "Therapist";
  const isRolePatient = userRole == "Patient";

  // USE EFFECTS

  useEffect(() => {
    trackScreenView("therapist_list_screen", {
      screen_name: "Find Therapist",
      user_name: userDetails?.first_name ? `${userDetails.first_name} ${userDetails.last_name || ""}`.trim() : "",
      user_role: userDetails?.role,
    });
    fetch_initial_details();
  }, []);

  useEffect(() => {
    if (initial_loading) {
      submitFun();
    }
  }, [clear_field_state]);

  // FUNCTIONS

  async function fetch_initial_details() {
    setLoading(true);
    try {
      const query = extractQueryFromUrl(searchQuery.current);
      const res = isUser
        ? await filter_therapist(page_no, query)
        : await filter_therapist_public(page_no, query);
      const speciality_res = await get_speciality_types();
      const states_res = await get_states();
      const language_res = await get_language_list();

      if (
        res.status === 1 &&
        speciality_res.status === 1 &&
        states_res.status === 1 &&
        language_res.status === 1
      ) {
        setTherapistList([...res.data.result]);
        setTotalDocs(res.data.total_docs);
        setTotalPages(res.data.total_pages);
        const modifiedStateRes = states_res.data.map((item) => {
          return { label: item.title, value: item._id };
        });
        const modifiedLanguageRes = language_res.data.map((item) => {
          return { label: item.title, value: item._id };
        });

        setStatesList(modifiedStateRes);
        setlanguageList([...modifiedLanguageRes]);
        const typeId = speciality_res?.data?.[0]?._id;
        if (typeId) {
          const list_res = await get_speciality(typeId);
        if (list_res.status == 1) {
          const modifiedRes = list_res.data.map((item) => {
            return { label: item.title, value: item._id };
          });

          setSpecialityList([...modifiedRes]);
          setInitialLoading(true);
          setLoading(false);
        }
        }
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in fetch_initial_details", err);
    }
  }

  const handle_all_check = () => {
    function handle_methods(value) {
      [setOnline, setOffline].forEach((element) => {
        element(value);
      });
    }
    if (all) {
      handle_methods(false);
    } else {
      handle_methods(true);
    }
    setAll(!all);
  };

  const online_offline = (value, method, type) => {
    const isOnline = type == "online";
    method(!value);
    if (value) {
      setAll(false);
    } else if (isOnline) {
      if (offline) {
        setAll(true);
      }
    } else {
      if (online) {
        setAll(true);
      }
    }
  };

  const loadmore_therapist = async (pageNo) => {
    setLoading(true);
    try {
      const query = extractQueryFromUrl(submited_find_query);
      const res = isUser
        ? await filter_therapist(pageNo, query)
        : await filter_therapist_public(pageNo, query);

      if (res.status === 1) {
        setTherapistList([...res.data.result]);
        setTotalDocs(res.data.total_docs);
        setTotalPages(res.data.total_pages);
        setPageNo(pageNo);
        setLoading(false);
      } else {
        setLoading(false);
        consoleService("error in loadmore_therapist function ", res.message);
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in loadmore_therapist list api", err);
    }
  };

  function displayRange(pageNumber, length_numbers) {
    const numbersPerPage = 9;
    const startNumber = (pageNumber - 1) * numbersPerPage + 1;
    const endNumber = pageNumber * numbersPerPage;
    const distance_in_endNumber = endNumber - length_numbers;
    return `${totalDocs == 0 ? 0 : startNumber}-${
      endNumber > totalPages
        ? endNumber - distance_in_endNumber + (startNumber - 1)
        : endNumber
    }`;
  }

  const setQuery = (params) => {
    const url = new URL(searchQuery.current);
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.set(key, value);
    }

    searchQuery.current = url.toString();
  };

  const removeQueryParam = (paramToRemove) => {
    const urlObject = new URL(searchQuery.current);
    const searchParams = new URLSearchParams(urlObject.search);

    if (searchParams.has(paramToRemove)) {
      searchParams.delete(paramToRemove);

      urlObject.search = searchParams.toString();
      searchQuery.current = urlObject.toString();
    }
  };

  async function fetch_filtered_details(query) {
    setLoading(true);
    try {
      const res = isUser
        ? await filter_therapist(1, query)
        : await filter_therapist_public(1, query);

      if (res.status === 1) {
        setTherapistList([...res.data.result]);
        setTotalDocs(res.data.total_docs);
        setTotalPages(res.data.total_pages);

        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in fetch_filtered_details", err);
    }
  }

  const clearFieldFun = () => {
    const emptydaysArr = daysArray.map((item) => {
      const newItem = item;
      newItem.checked = false;
      return newItem;
    });

    const emptyexperienceArr = experienceArr.map((item) => {
      const newItem = item;
      newItem.checked = false;
      return newItem;
    });

    setDaysArray([...emptydaysArr]);
    setExperienceArray([...emptyexperienceArr]);
    setState([]);
    setSpeciality([]);
    setPrice(39);
    setOnline(false);
    setOffline(false);
    setAll(false);
    setName("");
    setGender("");
    setLanguage([]);
    setRating("");
    setClearFieldState(!clear_field_state);
  };

  const days_check_uncheck_fun = (id) => {
    const check = daysArray.some((item) => {
      return item.id == id && item.checked == false;
    });
    if (check) {
      const newArray = daysArray.map((item) => {
        if (item.id == id) {
          item.checked = check;

          return item;
        } else {
          return item;
        }
      });
      setDaysArray([...newArray]);
    } else {
      const newArray = daysArray.map((item) => {
        if (item.id == id) {
          item.checked = check;
          return item;
        } else {
          return item;
        }
      });
      setDaysArray([...newArray]);
    }
  };

  const experience__check_uncheck_fun = (id) => {
    const check = experienceArray.some((item) => {
      return item.id == id && item.checked == false;
    });
    if (check) {
      const newArray = experienceArray.map((item) => {
        if (item.id == id) {
          item.checked = check;

          return item;
        } else {
          item.checked = false;
          return item;
        }
      });
      setExperienceArray([...newArray]);
    } else {
      const newArray = experienceArray.map((item) => {
        if (item.id == id) {
          item.checked = check;
          return item;
        } else {
          return item;
        }
      });
      setExperienceArray([...newArray]);
    }
  };

  const submitFun = () => {
    try {
      if (!name) {
        removeQueryParam("name");
      }
      if (!speciality.length > 0) {
        removeQueryParam("speciality_id");
      }
      if (!state.length > 0 || state.length == statesList.length) {
        removeQueryParam("state");
      }
      if (!language.length > 0) {
        removeQueryParam("language");
      }

      if (!price || price <= 0) {
        removeQueryParam("pricing");
      }
      if (!rating) {
        removeQueryParam("ratings");
      }
      if (!gender) {
        removeQueryParam("gender");
      }
      removeQueryParam("online_status");
      const filteredAvailability = [];
      daysArray.forEach((item) => {
        item.checked && filteredAvailability.push(item.day);
      });
      if (filteredAvailability.length) {
        setQuery({ availability: filteredAvailability.toString() });
      } else {
        removeQueryParam("availability");
      }
      if (!all) {
        if (online) {
          setQuery({ online_status: true });
        } else if (offline) setQuery({ online_status: false });
      }
      const Experience = experienceArray.filter((item) => {
        return item.checked == true;
      });
      if (Experience.length) {
        setQuery({ experience_min: Experience[0].startValue });
        if (Experience[0].endValue) {
          setQuery({ experience_max: Experience[0].endValue });
        }
      } else {
        removeQueryParam("experience_min");
        removeQueryParam("experience_max");
      }
      const query = extractQueryFromUrl(searchQuery.current);

      setSubmitedFindQuery(searchQuery.current);
      fetch_filtered_details(query);
      setPageNo(1);
    } catch (err) {
      setLoading(false);
      consoleService("Error in submitFun api", err);
    }
  };

  const add_to_favorite_fun = async (therapist_id, status) => {
    try {
      setSeletcedCard(therapist_id);
      setFavLoading(true);
      const data = {
        therapist_id,
        status: !status,
      };
      const res = await add_to_favorite(data);

      if (res.status === 1) {
        const newTherapistList = therapistList.map((item) => {
          if (item._id == therapist_id) {
            const orgItem = item;
            orgItem.isFavorite = res.data.status;
            return orgItem;
          } else {
            return item;
          }
        });
        setTherapistList([...newTherapistList]);
        setSeletcedCard(null);
        setFavLoading(false);
      }
    } catch (err) {
      consoleService("error in add t favorite fun = ", err);
    }
  };

  const set_login_role = () => {
    setAuthRole("Patient");
    localStorage.setItem("E_C_R_O_L_E", enctyptDataFun("Patient"));
  };

  return (
    <>
      <BannerSection banner={Banner} name={"Home"} title={"Find a therapist"} />
      <section className="py-5 bg_light">
        <div className="container">
          <div
            className="row"
            style={{ backgroundColor: "white", paddingTop: 10 }}
          >
            <div className="col-md-4">
              <StickyBox offsetTop={20} offsetBottom={20}>
                <Form>
                  <div className="leftside shadow_filter_box">
                    <div className="sidebar_header">
                      <h4 className="searchtitle">Search Filter</h4>
                      <Link
                        onClick={() => {
                          searchQuery.current = ConstConfig.MAIN_URL;
                          setSubmitedFindQuery(ConstConfig.MAIN_URL);
                          clearFieldFun();
                        }}
                      >
                        Clear Filter
                      </Link>
                    </div>
                    <div className="leftContent">
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput2"
                      >
                        <Form.Control
                          type="search"
                          placeholder="Search Therapist By Name"
                          aria-describedby="passwordHelpBlock"
                          value={name}
                          onKeyDown={(e) => {
                            if (e.key == "Enter") {
                              e.preventDefault();
                              submitFun();
                            }
                          }}
                          onChange={(e) => {
                            const value = e.target.value;
                            setName(value);
                            setQuery({ name: value });
                          }}
                        />
                      </Form.Group>

                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label>Specialty</Form.Label>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput3"
                        >
                          <MultiSelect
                            options={specialityList}
                            value={speciality}
                            onChange={(value) => {
                              const values = value.map((item) => item.value);
                              setQuery({ speciality_id: values.toString() });
                              setSpeciality(value);
                            }}
                            labelledBy="Select Specialty"
                            className="checkBoxNew"
                          />
                        </Form.Group>
                      </Form.Group>

                      {/* <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput3"
                      >
                        <Form.Label>State of Resident</Form.Label>

                        <MultiSelect
                          options={statesList}
                          value={state}
                          onChange={(value) => {
                            const values = value.map((item) => item.value);
                            setQuery({ state: values.toString() });
                            setState(value);
                          }}
                          labelledBy="Select"
                          className="checkBoxNew"
                        />
                      </Form.Group> */}

                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput3"
                      >
                        <Form.Label>Availability</Form.Label>
                        {["checkbox"].map((type) => (
                          <div key={`default-${type}`} className="mb-3 boxFlex">
                            {daysArray.map((item, index) => {
                              return (
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={item.id}
                                  checked={item.checked}
                                  label={item.day}
                                  key={index}
                                  onClick={() => {
                                    days_check_uncheck_fun(item.id);
                                  }}
                                />
                              );
                            })}
                          </div>
                        ))}
                      </Form.Group>

                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput3"
                      >
                        <Form.Label>Status</Form.Label>
                        {["checkbox"].map((type) => (
                          <div
                            key={`default-${type}`}
                            className="mb-3 boxFlex1"
                          >
                            <Form.Check // prettier-ignore
                              type={type}
                              id="s1"
                              checked={online}
                              label="Online"
                              onChange={() => {
                                online_offline(online, setOnline, "online");
                              }}
                            />
                            <Form.Check // prettier-ignore
                              type={type}
                              id="s2"
                              label="Offline"
                              checked={offline}
                              onChange={() => {
                                online_offline(offline, setOffline, "offline");
                              }}
                            />
                            <Form.Check // prettier-ignore
                              type={type}
                              id="s3"
                              label="All"
                              checked={all}
                              onChange={() => {
                                handle_all_check();
                              }}
                            />
                          </div>
                        ))}
                      </Form.Group>

                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput3"
                      >
                        <Form.Label>Gender</Form.Label>
                        {["radio"].map((type) => (
                          <div
                            key={`default-${type}`}
                            className="mb-3 boxFlex1 boxFlex2"
                          >
                            <Form.Check // prettier-ignore
                              type={type}
                              id="g1"
                              label="Male"
                              name="gender"
                              checked={gender == "Male"}
                              onClick={() => {
                                if (gender == "Male") {
                                  setGender("");
                                } else {
                                  setGender("Male");
                                  setQuery({
                                    gender: "Male",
                                  });
                                }
                              }}
                            />
                            <Form.Check // prettier-ignore
                              type={type}
                              id="g2"
                              label="Female"
                              name="gender"
                              checked={gender == "Female"}
                              onClick={() => {
                                if (gender == "Female") {
                                  setGender("");
                                } else {
                                  setGender("Female");
                                  setQuery({
                                    gender: "Female",
                                  });
                                }
                              }}
                            />
                            <Form.Check // prettier-ignore
                              type={type}
                              id="g3"
                              label="Unspecified"
                              name="gender"
                              checked={gender == "Unspecified"}
                              onClick={() => {
                                if (gender == "Unspecified") {
                                  setGender("");
                                } else {
                                  setGender("Unspecified");
                                  setQuery({
                                    gender: "Unspecified",
                                  });
                                }
                              }}
                            />
                          </div>
                        ))}
                      </Form.Group>

                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label>Language Preference</Form.Label>
                        <MultiSelect
                          options={languageList}
                          value={language}
                          onChange={(value) => {
                            const values = value.map((item) => item.value);
                            setQuery({ language: values.toString() });
                            setLanguage(value);
                          }}
                          labelledBy="Select"
                          className="checkBoxNew"
                        />
                      </Form.Group>

                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label>Price ${price}</Form.Label>
                        <RangeSlider
                          min={39}
                          max={150}
                          value={price}
                          color="red"
                          onChange={(changeEvent) => {
                            setPrice(changeEvent.target.value);
                            if (
                              changeEvent.target.value > 39 &&
                              changeEvent.target.value < 150
                            ) {
                              setQuery({ pricing: changeEvent.target.value });
                            } else {
                              removeQueryParam("pricing");
                            }
                          }}
                          tooltipLabel={() => {
                            return price == 150 ? `$${price}+` : `$${price}`;
                          }}
                        />
                      </Form.Group>

                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput3"
                      >
                        <Form.Label>Minimum Ratings</Form.Label>
                        {["checkbox"].map((type) => (
                          <div key={`default-${type}`} className="mb-3">
                            <Form.Check // prettier-ignore
                              type={type}
                              id="star1"
                              checked={rating == 1}
                              onClick={() => {
                                if (rating == 1) {
                                  setRating("");
                                } else {
                                  setRating(1);
                                  setQuery({ ratings: 1 });
                                }
                              }}
                              label={
                                <div className="starDetails">
                                  <FaStar />
                                </div>
                              }
                            />
                            <Form.Check // prettier-ignore
                              type={type}
                              id="star2"
                              checked={rating == 2}
                              onClick={() => {
                                if (rating == 2) {
                                  setRating("");
                                } else {
                                  setRating(2);
                                  setQuery({ ratings: 2 });
                                }
                              }}
                              label={
                                <div className="starDetails">
                                  <FaStar />
                                  <FaStar />
                                </div>
                              }
                            />
                            <Form.Check // prettier-ignore
                              type={type}
                              id="star3"
                              checked={rating == 3}
                              onClick={() => {
                                if (rating == 3) {
                                  setRating("");
                                } else {
                                  setRating(3);
                                  setQuery({ ratings: 3 });
                                }
                              }}
                              label={
                                <div className="starDetails">
                                  <FaStar />
                                  <FaStar />
                                  <FaStar />
                                </div>
                              }
                            />
                            <Form.Check // prettier-ignore
                              type={type}
                              id="star4"
                              checked={rating == 4}
                              onClick={() => {
                                if (rating == 4) {
                                  setRating("");
                                } else {
                                  setRating(4);
                                  setQuery({ ratings: 4 });
                                }
                              }}
                              label={
                                <div className="starDetails">
                                  <FaStar />
                                  <FaStar />
                                  <FaStar />
                                  <FaStar />
                                </div>
                              }
                            />
                            <Form.Check // prettier-ignore
                              type={type}
                              id="star5"
                              checked={rating == 5}
                              onClick={() => {
                                if (rating == 5) {
                                  setRating("");
                                } else {
                                  setRating(5);
                                  setQuery({ ratings: 5 });
                                }
                              }}
                              label={
                                <div className="starDetails">
                                  <FaStar />
                                  <FaStar />
                                  <FaStar />
                                  <FaStar />
                                  <FaStar />
                                </div>
                              }
                            />
                          </div>
                        ))}
                      </Form.Group>

                      <Button
                        className="btn btn-primary me-3"
                        onClick={() => {
                          submitFun();
                        }}
                      >
                        Apply
                      </Button>
                    </div>
                  </div>
                </Form>
              </StickyBox>
            </div>

            <div className="col-md-8">
              <div className="colFix">
                <h6 className="showingText">
                  Showing Therapist :{" "}
                  {displayRange(page_no, therapistList.length)} of {totalDocs}
                </h6>

                <div className="row">
                  {initial_loading && therapistList.length > 0 ? (
                    therapistList.map((item, index) => {
                      const itemId = item._id;
                      const isCurrentCardSelected = selected_card == itemId;
                      const current_item_in_fav_process =
                        isCurrentCardSelected && fav_loading;
                      return (
                        <div key={index} className="col-md-6 col-lg-4">
                          <Tooltip
                            id="my-tooltip-s"
                            className="tooltip-custom-container"
                          />
                          <div className="popukarsection rightside">
                            <div className="carousel_box">
                              <div className="item_box">
                                {item.online_status ? (
                                  <span
                                    className="online"
                                    style={{ backgroundColor: "#4CD964" }}
                                  ></span>
                                ) : (
                                  <span
                                    className="online"
                                    style={{ backgroundColor: "#9E9E9E" }}
                                  ></span>
                                )}
                                <div className="item_body ">
                                  <Link to={`/therapistdetailspage/${itemId}`}>
                                    <UserAvatar
                                      profileImage={item.profile_img}
                                      firstName={item.first_name || item.name}
                                      lastName={item.last_name}
                                      size="lg"
                                      className="img-fluid"
                                      alt={`${item.name} profile`}
                                    />
                                  </Link>

                                  <div className="d-flex align-items-center justify-content-between mb-2 ">
                                    <h2 className="truncate-text">
                                      <Link
                                        to={`/therapistdetailspage/${itemId}`}
                                      >
                                        {item.name}
                                      </Link>
                                    </h2>
                                    <div className="star">
                                      <StarRatings
                                        rating={parseFloat(
                                          Number(item.ratings).toFixed(1)
                                        )}
                                        starRatedColor="#FF674F"
                                        numberOfStars={5}
                                        name="rating"
                                        starDimension="15px"
                                        starSpacing={1}
                                      />
                                    </div>
                                  </div>

                                  <p
                                    data-tooltip-id="my-tooltip-s"
                                    data-tooltip-content={item.speciality}
                                    className="truncated-text tooltip-container"
                                  >
                                    {item.speciality}
                                  </p>
                                  {/* <h4>{item.speciality}</h4> */}

                                  <p
                                    data-tooltip-id="my-tooltip-s"
                                    data-tooltip-content={item.bio}
                                    style={{
                                      display: "-webkit-box",
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden",
                                      WebkitLineClamp: 2,
                                      textOverflow: "ellipsis",
                                      position: "relative",
                                    }}
                                  >
                                    {item.bio}
                                  </p>
                                  <div className="bookgap">
                                    <Link
                                      to={`/therapistdetailspage/${itemId}`}
                                      className="btn btn-primary"
                                      onClick={() => {
                                        trackButtonClick("view_therapist_cta", {
                                          button_name: "Book Now",
                                          screen_name: "Find Therapist",
                                          user_name: userDetails?.first_name ? `${userDetails.first_name} ${userDetails.last_name || ""}`.trim() : "",
                                          user_role: userDetails?.role,
                                          therapist_name: item.name,
                                        });
                                      }}
                                    >
                                      Book Now
                                    </Link>

                                    <div
                                      className="fav_btn cursor-pointer"
                                      as="button"
                                      onClick={() => {
                                        if (fav_loading) return;
                                        if (isRolePatient) {
                                          add_to_favorite_fun(
                                            itemId,
                                            item.isFavorite
                                          );
                                        } else {
                                          set_login_role();
                                          navigate("/login");
                                        }
                                      }}
                                      to={isUser ? "" : "/login"}
                                    >
                                      {current_item_in_fav_process ? (
                                        <FavLoader />
                                      ) : item.isFavorite ? (
                                        <FaHeart style={{ color: "#ff674f" }} />
                                      ) : (
                                        <FaRegHeart />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <>
                      {initial_loading &&
                        (isUser ? (
                          <view
                            style={{
                              height: "80vh",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              textAlign: "center",
                              paddingLeft: 50,
                              paddingRight: 50,
                              position: "relative",
                            }}
                          >
                            <span className="searchgif_txt">
                              No Therapists Found in Your State <br /> Please
                              adjust your filters or check back later.
                            </span>
                          </view>
                        ) : (
                          <view
                            style={{
                              height: "80vh",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              position: "relative",
                            }}
                          >
                            <span className="searchgif_txt">
                              No Therapists Found <br /> Please adjust your
                              filters or check back later.
                            </span>
                          </view>
                        ))}
                    </>
                  )}
                </div>

                <div className="text-center d-flex justify-content-center mb-3 mt-auto">
                  {totalPages > 1 && (
                    <Stack spacing={2}>
                      <Pagination
                        count={totalPages}
                        page={Number(page_no)}
                        onChange={(_, page) => {
                          loadmore_therapist(page);
                        }}
                      />
                    </Stack>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FindTherapist;
